import React, { useState } from "react";
import { Pagination } from "react-bootstrap";
import { Icon } from "@iconify/react";

const PaginatedList = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  return (
    <div className="d-flex justify-content-between align-items-center">
      <span>
        Showing {itemsPerPage * (currentPage - 1) + 1} to{" "}
        {Math.min(itemsPerPage * currentPage, totalItems)} of {totalItems}
      </span>
      <Pagination>
        <Pagination.Prev
          className="iconPos"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <Icon icon="fa-solid:caret-left" fontSize={19} />
        </Pagination.Prev>
        {[...Array(totalPages)].map((_, index) => (
          <Pagination.Item
            key={index + 1}
            active={index + 1 === currentPage}
            onClick={() => onPageChange(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next
          className="iconPos"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <Icon icon="fa-solid:caret-right" color="#000000" fontSize={19} />
        </Pagination.Next>
      </Pagination>
    </div>
  );
};

export default PaginatedList;
